export default "__VITE_ASSET__BggXsvSf__"